import { useContext } from "react";

import { AuthContext } from "@/contexts/authContext";

export const useLoggedInUser = () => {
  const authContext = useContext(AuthContext);
  const currentUser = authContext.currentUser;
  if (!currentUser) {
    throw new Error("useCurrentUser must be used within an AuthContext");
  }
  return currentUser;
};
